import * as attachmentAnalysisType from "../../action/actiontype/AttachmentAnalysisType/AttachmentAnalysisType";

const AttachmentAnalysisReducer = (state = {}, action) => {

    switch (action.type) {

        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_REQUEST_GETBYALL:
            return {
                ...state,
                attachmentAnalysisGetAllIdLoading: true,
                attachmentAnalysisGetAllIdResponse: {},
                attachmentAnalysisGetAllIdError: null,
            }

        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_SUCCESS_GETBYALL:
            return {
                ...state,
                attachmentAnalysisGetAllIdLoading: false,
                attachmentAnalysisGetAllIdResponse: action.payload,
                attachmentAnalysisGetAllIdError: null,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_FAILURE_GETBYALL:
            return {
                ...state,
                attachmentAnalysisGetAllIdLoading: false,
                attachmentAnalysisGetAllIdResponse: {},
                attachmentAnalysisGetAllIdError: action.payload,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_REQUEST_ADD:
            return {
                ...state,
                attachmentAnalysisAddLoading: true,
                attachmentAnalysisAddResponse: {},
                attachmentAnalysisAddError: null,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_SUCCESS_ADD:
            return {
                ...state,
                attachmentAnalysisAddLoading: false,
                attachmentAnalysisAddResponse: action.payload,
                attachmentAnalysisAddError: null,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_FAILURE_ADD:
            return {
                ...state,
                attachmentAnalysisAddLoading: false,
                attachmentAnalysisAddResponse: {},
                attachmentAnalysisAddError: action.payload,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_REQUEST_UPDATE:
            return {
                ...state,
                attachmentAnalysisUpdateLoading: true,
                attachmentAnalysisUpdateResponse: {},
                attachmentAnalysisUpdateError: null,
            }

        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_SUCCESS_UPDATE:
            return {
                ...state,
                attachmentAnalysiUpdateLoading: false,
                attachmentAnalysisUpdateResponse: action.payload,
                attachmentAnalysisUpdateError: null,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_FAILURE_UPDATE:
            return {
                ...state,
                attachmentAnalysisAddLoading: false,
                attachmentAnalysisAddResponse: {},
                attachmentAnalysisAddError: action.payload,
            }

        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_REQUEST_DELETE:
            return {
                ...state,
                attachmentAnalysisDeleteLoading: true,
                attachmentAnalysisDeleteResponse: {},
                attachmentAnalysisDeleteError: null,
            }

        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_SUCCESS_DELETE:
            return {
                ...state,
                attachmentAnalysisDeleteLoading: false,
                attachmentAnalysisDeleteResponse: action.payload,
                attachmentAnalysisDeleteError: null,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_FAILURE_DELETE:
            return {
                ...state,
                attachmentAnalysisDeleteLoading: false,
                attachmentAnalysisDeleteResponse: {},
                attachmentAnalysisDeleteError: action.payload,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_REQUEST_GETBYID:
            return {
                ...state,
                attachmentAnalysisGetIdLoading: true,
                attachmentAnalysisGetIdResponse: {},
                attachmentAnalysisGetIdError: null,
            }

        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_SUCCESS_GETBYID:
            return {
                ...state,
                attachmentAnalysisGetIdLoading: false,
                attachmentAnalysisGetIdResponse: action.payload,
                attachmentAnalysisGetIdError: null,
            }
        case attachmentAnalysisType.ATTACHMENT_ANALYSIS_FAILURE_GETBYID:
            return {
                ...state,
                attachmentAnalysisGetIdLoading: false,
                attachmentAnalysisGetIdResponse: {},
                attachmentAnalysisGetIdError: action.payload,
            }

        default:
            return state;
    }


}

export default AttachmentAnalysisReducer;